import LCDPlugin, { Env } from '../../kastjs/lcdp';
import merge from 'lodash/merge';
import { aopFactory } from './aop';
import { UpmReact } from '../../kastjs/upm';

export const lcdpluginAOP = aopFactory(LCDPlugin, {
  before(_, params, options) {
    return merge(
      {
        env: options.env === 'production' ? Env['production'] : Env['TEST'],
        sharedModules: { UpmReact },
        // @ts-ignore
        ...(options?.axios && typeof options?.axios === 'object'
          ? // @ts-ignore
            { axiosInstance: options?.axios?.instance }
          : {}),
      },
      params
    );
  },
});
